/**
 * Set the first time anything opens the file previewer. App.vue mounts the (lazy) FilePreviewHost on it, without
 * importing the previewer's loaders into the app's entry chunk.
 */
import { ref } from 'vue'

export const filePreviewRequested = ref(false)
